// extracted by mini-css-extract-plugin
export default {"container":"authLayout_container__yv7Uk"};